import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22CaireFont.tsx%22,%22import%22:%22Lato%22,%22arguments%22:[{%22weight%22:[%22100%22,%22400%22,%22700%22],%22style%22:[%22normal%22,%22italic%22],%22subsets%22:[%22latin%22],%22variable%22:%22--fontFamily%22}],%22variableName%22:%22customFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Lato', 'Lato Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
